// extracted by mini-css-extract-plugin
export default {"bottom":"bottom__8299f0c3","content_wrapper":"content_wrapper__8299f0c3","content":"content__8299f0c3","submit":"submit__8299f0c3"};